__turbopack_context__.v({
  "afb__preview-link": "AmazonPreviewLink-module__jzCoBa__afb__preview-link",
  "bookCard": "AmazonPreviewLink-module__jzCoBa__bookCard",
  "center": "AmazonPreviewLink-module__jzCoBa__center",
});
